import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const GastritisPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Gastritis</h1>
        <section className="mb-8">
          <p>Gastritis is the inflammation of the stomach lining, causing pain and digestive discomfort. Our natural therapies focus on healing the stomach lining, reducing inflammation, and promoting digestive health through herbal remedies and lifestyle changes.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>H. pylori infection</li>
            <li>Poor dietary habits</li>
            <li>Excessive alcohol consumption</li>
            <li>Stress</li>
            <li>Certain medications</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Stomach pain</li>
            <li>Bloating</li>
            <li>Nausea and vomiting</li>
            <li>Loss of appetite</li>
            <li>Indigestion</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use healing herbs, anti-inflammatory remedies, and dietary modifications to naturally treat gastritis. Our approach focuses on healing the stomach lining and preventing recurrence through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Heals stomach lining</li>
            <li>Reduces inflammation</li>
            <li>No harsh side effects</li>
            <li>Long-term relief</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eat a balanced, light diet</li>
            <li>Avoid spicy and acidic foods</li>
            <li>Manage stress</li>
            <li>Limit alcohol and caffeine</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Many patients notice improvement within 2-4 weeks of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for long-term use?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for long-term management.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent recurrence?</strong>
            <p>A: Yes, our holistic approach helps prevent recurrence by addressing root causes.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from gastritis—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default GastritisPage; 